import { render, staticRenderFns } from "./ListLusazu.vue?vue&type=template&id=172809eb&scoped=true"
import script from "./ListLusazu.vue?vue&type=script&lang=js"
export * from "./ListLusazu.vue?vue&type=script&lang=js"
import style0 from "./ListLusazu.vue?vue&type=style&index=0&id=172809eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172809eb",
  null
  
)

export default component.exports